import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./PreviewModal.scss";
import LeftArrowIcon from "../icons/LeftArrowIcon";
import RightArrowIcon from "../icons/RightArrowIcon";

interface PreviewModalProps {
  open: boolean;
  onClose: () => void;
  images: string[];
  initialIndex?: number;
  children?: React.ReactNode;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  open,
  onClose,
  images,
  initialIndex = 0,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) setCurrentIndex(initialIndex);
  }, [open, initialIndex]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      maxWidth={false}
      className="brand-view-preview-modal"
      classes={{
        root: "brand-view-preview-modal-root",
        paper: "brand-view-preview-modal-paper",
      }}
      BackdropProps={{
        className: "brand-view-preview-modal-backdrop",
      }}
    >
      <div className="brand-view-preview-modal-container">
        <IconButton className="brand-view-preview-close-btn" onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <div className="brand-view-preview-modal-body">
          {images.length > 0 && (
            <img
              src={images[currentIndex]}
              alt={`Preview ${currentIndex + 1}`}
              className="brand-view-preview-image"
            />
          )}

          {images.length > 1 && (
            <>
              <button
                className="brand-view-carousel-button brand-view-left"
                onClick={handlePrev}
              >
                <LeftArrowIcon />
              </button>
              <button
                className="brand-view-carousel-button brand-view-right"
                onClick={handleNext}
              >
                <RightArrowIcon />
              </button>

              <div className="brand-view-mobile-carousel-buttons">
                <button onClick={handlePrev}>
                  <LeftArrowIcon />
                </button>
                <button onClick={handleNext}>
                  <RightArrowIcon />
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PreviewModal;
